export default __webpack_public_path__ + "static/media/Intel_Core_i3_Logo_2020.e8f4eb75.svg";